// ============================================
// ROLC OneROLC - Toast Component
// Version: 3.6.0
// ============================================

let toastContainer = null;
let toastTimeouts = [];

export function showToast(message, type = 'info', duration = 3000) {
    if (!toastContainer) {
        toastContainer = document.createElement('div');
        toastContainer.id = 'toast-container';
        toastContainer.style.cssText = `
            position: fixed;
            top: 60px;
            right: 16px;
            z-index: 99999;
            display: flex;
            flex-direction: column;
            gap: 8px;
            pointer-events: none;
        `;
        document.body.appendChild(toastContainer);
    }

    const colors = {
        success: { bg: '#d1fae5', text: '#065f46', icon: '✅' },
        error:   { bg: '#fee2e2', text: '#991b1b', icon: '❌' },
        info:    { bg: '#dbeafe', text: '#1e40af', icon: 'ℹ️' },
        warning: { bg: '#fef3c7', text: '#92400e', icon: '⚠️' }
    };
    const c = colors[type] || colors.info;

    const toast = document.createElement('div');
    toast.style.cssText = `
        background: ${c.bg};
        color: ${c.text};
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 0.9rem;
        font-weight: 600;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        pointer-events: auto;
        animation: toastIn 0.25s ease-out;
        display: flex;
        align-items: center;
        gap: 8px;
        max-width: 400px;
    `;
    toast.innerHTML = `<span>${c.icon}</span> ${message}`;
    toastContainer.appendChild(toast);

    toast.addEventListener('click', () => removeToast(toast));

    const timeout = setTimeout(() => removeToast(toast), duration);
    toastTimeouts.push(timeout);
}

function removeToast(toast) {
    if (!toast || !toast.parentNode) return;
    toast.style.transition = 'opacity 0.3s, transform 0.3s';
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(-10px)';
    setTimeout(() => {
        if (toast.parentNode) toast.remove();
    }, 300);
}

export function clearToasts() {
    if (toastContainer) {
        toastContainer.innerHTML = '';
    }
    toastTimeouts.forEach(clearTimeout);
    toastTimeouts = [];
}


